var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 18.75C27.5703 18.75 29.25 17.0703 29.25 15C29.25 12.9297 27.5703 11.25 25.5 11.25C23.4297 11.25 21.75 12.9297 21.75 15C21.75 15.1562 21.7578 15.3125 21.7773 15.4648L18.1016 17.3008C17.4297 16.6484 16.5117 16.25 15.5 16.25C13.4297 16.25 11.75 17.9297 11.75 20C11.75 22.0703 13.4297 23.75 15.5 23.75C16.5117 23.75 17.4297 23.3516 18.1016 22.6992L21.7773 24.5352C21.7578 24.6875 21.75 24.8398 21.75 25C21.75 27.0703 23.4297 28.75 25.5 28.75C27.5703 28.75 29.25 27.0703 29.25 25C29.25 22.9297 27.5703 21.25 25.5 21.25C24.4883 21.25 23.2031 22.2383 22.5312 22.8906L19.2227 21.25C19.2227 22.0352 19.2227 21.25 19.25 20C19.25 19.8398 19.2422 18.9023 19.2227 18.75L22.5312 17.3008C23.2031 17.9531 24.4883 18.75 25.5 18.75Z",
    fill: "#1A2021"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#DBDBDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.371b346088d4591c6aebac6197462815.svg";
export { ForwardRef as ReactComponent };